import React from 'react'
import PropTypes from 'prop-types'
import { nanoid } from 'nanoid'

// components
import { Checkbox } from '../../index'

// utils
import { getClassName, THEMES } from '../../../utils'

import './bulkActionBar.component.scss'

import { CrmWriteGate } from '../../crmWriteGate/CrmWriteGate.component'

const propTypes = {
  className: PropTypes.string,
  isVisible: PropTypes.bool,
  isBulkSelected: PropTypes.bool,
  actions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    label: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    /** When true, wraps the action in `CrmWriteGate` (Redux CRM read-only). */
    crmWriteGate: PropTypes.bool,
  })).isRequired,
  onChange: PropTypes.func.isRequired
}

const defaultProps = {
  actions: [],
  isVisible: false
}

/**
 * BulkActionBar Wrapping Component
 * @param props
 */
function BulkActionBar (props) {
  const { className, isVisible, isBulkSelected, actions, onChange } = props

  const componentId = nanoid()
  const baseClassName = getClassName('bulk-action-bar', [
    { condition: className, trueClassName: className },
    { condition: isVisible, falseClassName: 'bulk-action-bar--hidden' }
  ])

  return (
    <section className={baseClassName}>
      <div className='bulk-action-bar_checkbox'>
        <Checkbox
          theme={THEMES.Q4_BLUE}
          id={`bulk-action-checkbox--${componentId}`}
          isSelected={isBulkSelected}
          onChange={onChange}
        />
      </div>
      <ul className='bulk-action-bar_actions'>
        {(actions || []).map((item) => {
          const { dataId, id, className, icon, label, onSelect, crmWriteGate = false } = (item || {})
          const row = (
            <li
              data-id={dataId}
              className={`bulk-action-bar_actions-item ${className || ''}`}
              onClick={onSelect}
            >
              {icon && <i className={`bulk-action-bar_actions-icon ${icon}`} />}
              {label && <span className='bulk-action-bar_actions-label'>{label}</span>}
            </li>
          )
          return crmWriteGate ? (
            <CrmWriteGate key={`bulk-action-gate--${id}`} className='crm-write-gate bulk-action-bar_actions-item-gate'>
              {row}
            </CrmWriteGate>
          ) : React.cloneElement(row, { key: `bulk-action--${id}` })
        })}
      </ul>
    </section>
  )
}

BulkActionBar.propTypes = propTypes
BulkActionBar.defaultProps = defaultProps

export default BulkActionBar
